import axios from "./Axios";

// check token

export const CheckToken = (Data: FormData) => {
  return axios.post("check_token", Data);
};

//login
export const LoginApi = (Data: FormData) => {
  return axios.post("login_user", Data);
  // login_user
  //login
};

//signup

export const RegisterApi = (Data: FormData) => {
  return axios.post("signup_user", Data);
};

//verifyotp

export const VerifyOtp = (Data: FormData) => {
  return axios.post("otp_verification", Data);
};

//resend

export const ResendOtp = (Data: FormData) => {
  return axios.post("resend_otp", Data);
};

//change password

export const Changepassword = (Data: FormData) => {
  return axios.post("reset_password", Data);
};

//forgotpassword and organization

export const frogotpassandorgService = (data: FormData) => {
  return axios.post("/generate_otp", data);
};

//create organization code

export const CreateOrganizationCode = (Data: FormData) => {
  return axios.post("org_code", Data);
};

//logout

export const LogoutApi = (Data: FormData) => {
  return axios.post("logout", Data);
};

//changePassword

export const ChangePasswprd = (Data: FormData) => {
  return axios.post("changePassword", Data);
};

//dashboard

export const DashboardData = (Data: FormData) => {
  return axios.post("mqtt_data/mqtt_dashboard", Data);
};

export const EnergyConsumptionReportService = (data: FormData) => {
  return axios.post("report/EnergyConsumptionReportGraph", data);
};

export const EnergyConsumptionTableService = (
  page: number,
  size: number,
  data: FormData
) => {
  return axios.post(
    `report/energyConsumptionReport?page=${page}&size=${size}`,
    data
  );
};

export const ConsumptionHistoryTableService = (
  page: number,
  size: number,
  data: FormData
) => {
  return axios.post(
    `report/consumptionHistoryReport?page=${page}&size=${size}`,
    data
  );
};

export const FailureAnalysisService = (Data: FormData) => {
  return axios.post("report/failureAnalysis", Data);
};

//repots page
export const ReportsListData = (
  Data: FormData,
  page: number,
  size: number,
  api: string
) => {
  return axios.post(`${api}?page=${page}&size=${size}`, Data);
};

//device page

export const DeviceListData = (Data: FormData, page: number, size: number) => {
  return axios.post(`device/listDevice?page=${page}&size=${size}`, Data);
};

export const DeleteDeviceDate = (Data: FormData) => {
  return axios.post("device/deleteDevice", Data);
};

export const CreateDeviceDate = (Data: FormData) => {
  return axios.post("device/add_device", Data);
};

export const UpdateDeviceDate = (Data: FormData) => {
  return axios.post("device/updateDevice", Data);
};

export const ViewDeviceData = (Data: FormData) => {
  return axios.post("/device/viewDevice", Data);
};

// Motor Dashboard

export const ConsumptionHistoryReport = (
  page = 1,
  size = 10,
  data: FormData
) => {
  return axios.post(
    `/report/consumptionHistoryReport?page=${page}&size=${size}`,
    data
  );
};

export const ConsumptionHistoryReportGraph = (data: FormData) => {
  return axios.post(`/report/consumptionHistoryGraph`, data);
};

//notification settings

export const ViewUserService = (data: FormData) => {
  return axios.post(`/viewUser`, data);
};

export const EditAccessService = (data: FormData) => {
  return axios.post(`/editAccess`, data);
};

//dropdowns

export const DropdownService = (data: FormData, api: string) => {
  return axios.post(`/dropdown/${api}`, data);
};

//meterlist

export const ListDeviceMeter = (data: FormData, page: number, size: number) => {
  return axios.post(`/meter/list_meter?page=${page}&size=${size}`, data);
};

export const CreateDeviceMeter = (data: FormData) => {
  return axios.post(`meter/add_meter`, data);
};

export const UpdateDeviceMeter = (data: FormData) => {
  return axios.post(`meter/update_meter`, data);
};

export const DeleteDeviceMeter = (data: FormData) => {
  return axios.post(`meter/delete_meter`, data);
};

export const ReplaceMeterService = (data: FormData) => {
  return axios.post("meter/replace_meter", data);
};

export const ResetMetervalueService = (data: FormData) => {
  return axios.post("/meter/reset_meter_value", data);
};

//alert settings

export const ListDeviceAlertSettings = (
  data: FormData,
  page: number,
  size: number
) => {
  return axios.post(
    `/alert_setting/list_alert_setting?page=${page}&size=${size}`,
    data
  );
};

export const CreateDeviceAlertSettings = (data: FormData) => {
  return axios.post(`alert_setting/add_alert`, data);
};

export const DeleteDeviceAlertSettings = (data: FormData) => {
  return axios.post(`/alert_setting/delete_alert`, data);
};

//inutpin

export const ListDeviceInputPin = (data: FormData) => {
  return axios.post(`device_pin/list_pin?page=1&size=10`, data);
};

export const UpdateDeviceInputPin = (data: FormData) => {
  return axios.post(`device_pin/edit_pin`, data);
};

//publish congig

export const PublishConfigService = (data: FormData) => {
  return axios?.post("mqtt_data/data_publish", data);
};

//user

export const UseListService = (page: number, size: number, data: FormData) => {
  return axios.post(`listUser?page=${page}&size=${size}`, data);
};

export const DeleteUserData = (Data: FormData) => {
  return axios.post("deleteUser", Data);
};

export const CreateUserData = (data: FormData) => {
  return axios.post("addUser", data);
};

export const UpdateUserData = (data: FormData) => {
  return axios.post("editUser", data);
};

export const ChangeUserPassword = (data: FormData) => {
  return axios.post("changeUserPassword", data);
};

export const CreateUserDeviceMapping = (data: FormData) => {
  return axios.post("/mapping/createUserDeviceMapping", data);
};

export const UserListDeviceMapping = (
  page: number,
  size: number,
  data: FormData
) => {
  return axios.post(
    `/mapping/listUserDeviceMapping?page=${page}&size=${size}`,
    data
  );
};

export const UpdateUserDeviceMapping = (data: FormData) => {
  return axios.post("/mapping/editUserDeviceMapping", data);
};

export const DeleterUserDevice = (data: FormData) => {
  return axios.post("/mapping/deleteUserDeviceMapping", data);
};

//subscription

export const GetSubscription = (data: FormData) => {
  return axios.post("/subscription/getSubscription", data);
};

export const SendSubscription = (data: FormData) => {
  return axios.post("/subscription/sendSubscriptionRequest", data);
};

export const SubscriptionListService = (
  page: number,
  size: number,
  data: FormData
) => {
  return axios.post(
    `/subscription/subscription_list?page=${page}&size=${size}`,
    data
  );
};

//make and model dropdown

export const MakeDropdown = (data: FormData) => {
  return axios.post("/meter/list_brand", data);
};

export const ModelDropdown = (data: FormData) => {
  return axios.post("/meter/list_model", data);
};

// backedup data

export const MonthDropdown = (data: FormData) => {
  return axios.post("/dropdown/monthDropDown", data);
};

export const DeleteBackedupData = (data: FormData) => {
  return axios.post("/auto_api/delete_report", data);
};

//  Ai Reports
export const AIreports = (page: number, size: number, data: FormData) => {
  return axios.post(`/report/ai_alert_report?page=${page}&size=${size}`, data);
};

//Mail Settings

export const createMailSettings = (data: FormData) => {
  return axios.post("/create_mail_settings", data);
};

export const updateMailSettings = (data: FormData) => {
  return axios.post("/update_mail_settings", data);
};

export const viewMailSettings = (data: FormData) => {
  return axios.post("/view_mail_settings", data);
};

export const deleteMailSettings = (data: FormData) => {
  return axios.post("/delete_mail_settings", data);
};

export const listMailSettings = (
  page: number,
  size: number,
  data: FormData
) => {
  return axios.post(`/list_mail_setting?page=${page}&size=${size}`, data);
};

//dropdown

export const meterDropdown = (data: FormData) => {
  return axios.post("/dropdown/meterDropdown", data);
};

export const deviceDropdown = (data: FormData) => {
  return axios.post("/dropdown/dropDownDeviceMap", data);
};
